import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TechnicalSkillsSection from "./TechnicalSkillsSection";

import { ReactComponent as IconClear } from "../../../layout/others/icon_clear_reverse.svg";
import "./personalSkills.css";

export default function PersonalSkills({ interview, setInterview }) {
  const [tabCurrent, setTabCurrent] = useState(0);
  let { t } = useTranslation();

  function currentAtiveTab(tabIndex) {
    return tabIndex == tabCurrent ? " nav-link active" : "nav-link";
  }

  const TAB = { CORESKILLS: 0, OTHERSKILLS: 1, INTERESTSKILL: 2 };

  function setSelectedTechnologies(technologies) {
    let _currentTechnologies = [...interview.technologies];

    addOrUpdateTechnologies(technologies, _currentTechnologies);

    deleteIfmissingTechnologies(technologies, _currentTechnologies);

    _currentTechnologies = _currentTechnologies.sort(
      (a, b) => a.skillType - b.skillType
    );
    setInterview({ ...interview, technologies: _currentTechnologies });
  }

  function deleteIfmissingTechnologies(technologies, currenTechnologies) {
    let _currenTechnologies = [...currenTechnologies];
    for (let i = 0; i < _currenTechnologies.length; i++) {
      let notFound = true;
      if (_currenTechnologies[i].skillType === tabCurrent)
        for (let s = 0; s < technologies.length; s++) {
          if (technologies[s].id === _currenTechnologies[i].id) {
            notFound = false;
            break;
          }
        }
      else notFound = false;

      if (notFound) {
        currenTechnologies.splice(i, 1);
      }
    }
  }

  function addOrUpdateTechnologies(
    technologies,

    currentTechnologies
  ) {
    for (let tech of technologies) {
      let index = -1;

      for (let i = 0; i < currentTechnologies.length; i++) {
        if (
          currentTechnologies[i].id === tech.id &&
          currentTechnologies[i].skillType === tabCurrent
        ) {
          index = i;
          break;
        }
      }
      if (index == -1) {
        currentTechnologies.push({
          id: tech.id,
          skillType: tabCurrent,
          description: tech.description
        });
      }
    }
  }
  function onRemoveItemFromSelectList(id, skillType) {
    let index = -1;
    for (let i = 0; i < interview.technologies.length; i++) {
      if (
        interview.technologies[i].id === id &&
        interview.technologies[i].skillType === skillType
      ) {
        index = i;
        break;
      }
    }
    if (index == -1) return;
    let _technologies = [...interview.technologies];

    _technologies.splice(index, 1);
    setInterview({ ...interview, technologies: _technologies });
  }
  function selectedSummaryStyle(skillType) {
    if (skillType === TAB.CORESKILLS) {
      return "rounded-pill  p-2   core-skills";
    } else if (skillType === TAB.INTERESTSKILL) {
      return "rounded-pill  p-2   interested-skills ";
    } else {
      return "rounded-pill  p-2  other-skills";
    }
  }
  function selectSingleTechnology(selectedTechnology, selectedTechnologies) {
    let _currentTechnologies = [...selectedTechnologies];
    let index = _currentTechnologies
      .map((technology) => technology.id)
      .indexOf(selectedTechnology.id);
    if (index == -1) {
      _currentTechnologies.push(selectedTechnology);
      setSelectedTechnologies(_currentTechnologies);
    } else {
      onRemoveItemFromSelectList(selectedTechnology.id, tabCurrent);
    }
  }

  function selectMltipleTechnology(_technologies) {
    let _technologiesIds = _technologies.map((technology) => {
      return { id: technology.id, description: technology.description };
    });
    setSelectedTechnologies(_technologiesIds);
  }

  return (
    <div className="header-tabs" style={{marginTop: "70px"}}>
      <h4 className="m-4 label-position">{t("Technical Skills")}</h4>
      {interview.technologies.length == 0 ? (
        <div>{t("You can select multiple skills for each category.")}</div>
      ) : (
        <ul className="list-inline">
          {interview.technologies.map((x) => (
            <li className="list-inline-item mb-3 ">
              <span className={selectedSummaryStyle(x.skillType)}>
                {x.description}{" "}
                <i
                  class="bi bi-x-circle-fill"
                  onClick={() => onRemoveItemFromSelectList(x.id, x.skillType)}
                ></i>
              </span>
            </li>
          ))}
        </ul>
      )}
      <div className="m-4">
        <ul className="nav nav-tabs" role="tablist">
          <li role="presentation">
            <a
              className={currentAtiveTab(TAB.CORESKILLS)}
              onClick={() => setTabCurrent(TAB.CORESKILLS)}
            >
              {t("Core Skills")}
            </a>
          </li>{" "}
          <li role="presentation">
            <a
              className={currentAtiveTab(TAB.OTHERSKILLS)}
              onClick={() => setTabCurrent(TAB.OTHERSKILLS)}
            >
              {t("Other Skills")}
            </a>
          </li>{" "}
          <li role="presentation">
            <a
              className={currentAtiveTab(TAB.INTERESTSKILL)}
              onClick={() => setTabCurrent(TAB.INTERESTSKILL)}
            >
              {t("Interests Skills")}
            </a>
          </li>
        </ul>
        <div>
          <div className="tab-skill">
            <TechnicalSkillsSection
              selectedTechnologies={interview.technologies.filter(
                (x) => x.skillType === tabCurrent
              )}
              selectSingleTechnology={selectSingleTechnology}
              selectMltipleTechnology={selectMltipleTechnology}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
